import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ProductExperience } from 'app/profile/models/site.model';
import { MatDialog } from '@angular/material/dialog';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { Store } from '@ngrx/store';
import { TslDialog, PageEvent, TslSort } from '@tesla/ng-tds';
import { I18nService } from 'app/shared/services/i18n.service';
import { SiteService } from 'app/profile/services/site.service';
import { BehaviorSubject } from 'rxjs';
import { ProductFormDialogComponent } from '../product-form-dialog/product-form-dialog.component';

@Component({
    selector: 'app-product-grid',
    templateUrl: './product-grid.component.html',
    styleUrls: ['./product-grid.component.scss']
})
export class ProductGridComponent implements OnInit, OnChanges {
    @Input() supplierCode: string;
    @Input() siteId: number;
    deleteTitle: string;
    deleteConfirmation: string;

    // table
    pageIndex = 0;
    pageSize = 10;
    pageSizeOptions: number[] = [10, 25, 50, 100, 250];
    datasource: BehaviorSubject<Array<ProductExperience>> = new BehaviorSubject([]);
    productResult: ProductExperience[] = [];
    displayedColumns: Array<string> = ['commodity', 'years', 'volume', 'doesProduction', 'doesPrototype', 'action'];

    constructor(
        private siteService: SiteService,
        public translate: I18nService,
        private dialog: TslDialog,
        private store: Store<SupplierState>,
        private matDialog: MatDialog
    ) { }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.loadResources();
    }

    onPageChange(pageChange: PageEvent): void {
        const { pageIndex, pageSize } = pageChange;
        this.pageIndex = pageIndex;
        this.pageSize = pageSize;
        this.loadPage();
    }

    onSortChange(sort: TslSort): void {
        const orderedItems = this.productResult.sort((a, b) => {
            const isAsc = sort.direction === 'asc';

            switch (sort.active) {
                case 'commodity': return compare(a.commodityDescription.toLowerCase(), b.commodityDescription.toLowerCase(), isAsc);
                case 'years': return compare(a.experienceYears, b.experienceYears, isAsc);
                case 'volume': return compare(a.volume, b.volume, isAsc);
                default: return 0;
            }
        });

        const skip = this.pageIndex * this.pageSize;
        const take = (this.pageIndex + 1) * this.pageSize;
        this.datasource.next(orderedItems.slice(skip, take));

        function compare(a: number | string, b: number | string, isAsc: boolean) {
            return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
        }
    }

    onAdd(): void {
        this.openDialog(new ProductExperience());
    }

    onEdit(item: ProductExperience): void {
        this.openDialog(item);
    }

    onRemove(item: ProductExperience): void {
        this.siteService.deleteProductExperience(this.supplierCode, this.siteId, item.id)
            .subscribe(_ => {
                const index = this.productResult.findIndex(p => p.id === item.id);
                if (index > -1) {
                    this.productResult.splice(index, 1);
                    this.loadPage();
                }
            });
    }

    private openDialog(item: ProductExperience): void {
        item.siteId = this.siteId;
        const dialogRef = this.matDialog.open(ProductFormDialogComponent,
            { width: '99%', height: '90%', data: { supplierCode: this.supplierCode, model: item } });

        dialogRef.afterClosed()
            .subscribe((model: ProductExperience) => {
                if (!model) {
                    return;
                }

                if (model.id === undefined || model.id === 0) {
                    // create
                    this.siteService.postProductExperience(this.supplierCode, this.siteId, model)
                        .subscribe(res => {
                            this.productResult.push(res);
                            this.loadPage();
                        });
                } else {
                    // update
                    this.siteService.putProductExperience(this.supplierCode, this.siteId, model.id, model)
                        .subscribe(res => {
                            const index = this.productResult.findIndex(p => p.id === model.id);
                            if (index > -1) {
                                this.productResult[index] = res;
                            }
                            this.loadPage();
                        });
                }
            });
    }

    private loadPage(): void {
        const skip = this.pageIndex * this.pageSize;
        const take = (this.pageIndex + 1) * this.pageSize;
        this.datasource.next(this.productResult.slice(skip, take));
    }

    private loadResources(): void {
        this.siteService.getProductExperiences(this.supplierCode, this.siteId)
            .subscribe(res => {
                this.productResult = res;
                this.loadPage();
            });
    }
}
